import { Col, Row } from 'react-bootstrap-v5'
import { Modal } from 'rsuite'

type Props = {
  data: {
    rating: string
    reviewedData: {title: string}
    name: string
    email: string
    mobileNumber: string
    ratingMessage: string
  }
  handleClose: () => void
}
const ViewDetailsModal = ({handleClose, data}: Props) => {
  return (
    <div className='modal-container'>
      <Modal
        open={true}
        onClose={handleClose}
        className='w-75'
        backdrop='static'
        keyboard={false}
        enforceFocus={false}
        data-cy='modal'
      >
        <Modal.Header>
          <Modal.Title data-cy='modal-title'>Review Details </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Row>
              <Col md={6}>
                <b>Product Name</b>
              </Col>
              <Col md={6}>
                <p>{data.reviewedData?.title}</p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <b>User Name</b>
              </Col>
              <Col md={6}>
                <p>{data.name}</p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <b>Email</b>
              </Col>
              <Col md={6}>
                <p>{data.email || ' - '}</p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <b>Mobile Number</b>
              </Col>
              <Col md={6}>
                <p>{data.mobileNumber || ' - '}</p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <b>Rating</b>
              </Col>
              <Col md={6}>
                <p>{data?.rating || ' - '}</p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <b>Review Message</b>
              </Col>
              <Col md={6}>
                <p>{data?.ratingMessage || ' - '}</p>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default ViewDetailsModal
